const config = {
    API_BASE_URL: "http://localhost:8080",
  };
  
  export default config;